/* Guide pages (.llg, sections/ll-article.liquid): scroll reveal, the sticky bar's active dot and reading line, shop the mix.
   Add to cart on a bottle is the shared [data-add] handler in ll.js (it adds the variant and opens the cart drawer). */
(() => {
  const root = document.querySelector('.llg');
  if (!root) return;
  const $$ = (s, r = root) => [...r.querySelectorAll(s)];

  // the bar sticks under the sticky header, so it needs the header's height
  const hd = document.getElementById('hd2');
  const setHH = () => document.documentElement.style.setProperty('--hh', (hd && getComputedStyle(hd).position === 'sticky' ? hd.offsetHeight : 0) + 'px');
  setHH(); addEventListener('resize', setHH);

  // sections rise in as they reach the screen
  const io = new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('on'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -10% 0px' });
  $$('.Rv').forEach((r) => io.observe(r));

  // shop the mix: tick bottles, one total, one Add all
  const words = ['', 'one', 'two', 'three', 'four'];
  const money = (c) => `<small>$</small>${Math.floor(c / 100)}<sup>.${String(c % 100).padStart(2, '0')}</sup>`;
  function mixTotal(m) {
    const its = $$('.m-it', m), on = its.filter((x) => x.classList.contains('on')), btn = m.querySelector('[data-all]');
    m.querySelector('[data-tot]').innerHTML = money(on.reduce((s, x) => s + +x.dataset.p, 0));
    const w = (n) => words[n] || n;
    btn.textContent = !on.length ? 'Pick a bottle' : on.length === its.length ? `Add all ${w(on.length)}` : `Add ${w(on.length)}`;
  }
  $$('[data-mix]').forEach(mixTotal);

  root.addEventListener('click', (e) => {
    const it = e.target.closest('.m-it');
    if (it) { it.classList.toggle('on'); mixTotal(it.closest('[data-mix]')); return; }
    const all = e.target.closest('[data-all]');
    if (all) {
      const items = $$('.m-it.on', all.closest('[data-mix]')).map((x) => ({ id: Number(x.dataset.v), quantity: 1 }));
      if (items.length && window.LLcart) window.LLcart.add(items);
      return;
    }
    const to = e.target.closest('[data-to]');
    if (to) { e.preventDefault(); document.getElementById('gs' + to.dataset.to)?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  // where the reader is: opens that dot in the bar and fills the reading line
  const rows = $$('.R [data-k]'), dots = root.querySelector('.N-dots'), line = root.querySelector('.N-line'), body = root.querySelector('.R');
  if (!rows.length || !dots) return;
  let cur = -1;
  function onScroll() {
    let k = 0;
    rows.forEach((r) => { if (r.getBoundingClientRect().top < innerHeight * 0.45) k = +r.dataset.k; });
    if (k !== cur) {
      cur = k;
      $$('a', dots).forEach((a) => a.classList.toggle('on', +a.dataset.to === k));
      const on = dots.querySelector('a.on');
      if (on) dots.scrollTo({ left: on.offsetLeft - dots.offsetLeft - 40, behavior: 'smooth' });
    }
    const r = body.getBoundingClientRect();
    line.style.transform = `scaleX(${Math.min(1, Math.max(0, (innerHeight * 0.45 - r.top) / r.height))})`;
  }
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
